import {useContext} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {Users as UsersIcon, Disconnect as DisconnectIcon} from './IconCmp';
import {HiOutlineBackspace as BackIcon} from 'react-icons/hi';
import {BiVideo as CallIcon} from 'react-icons/bi';
import {BiVideoOff as HangUpIcon} from 'react-icons/bi';
import {FiMic as UnmutedIcon, FiMicOff as MutedIcon} from 'react-icons/fi';
import Button from './ButtonCmp';
import {WSState} from '../providers/WebSocketProvider';
import {VideoState, stopStreaming} from '../providers/VideoProvider';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.5rem;
`;

const ChatUIControlsCmp = ({isHost, showUsers, handleUsers, handleWarning, handleExit}) => {
  const {dispatch: wsDispatch} = useContext(WSState);
  const {state: vState, dispatch: vDispatch} = useContext(VideoState);

  const inCall = vState ? vState.inCall : null;
  const isMuted = vState ? vState.isMuted : null;

  const handleStartCall = () => {
    vDispatch({type: 'connect'});
  };

  const handleStopCall = async () => {
    await stopStreaming({unregister: true});

    vDispatch({type: 'disconnect'});

    wsDispatch({
      type: isHost ? 'host-end-call' : 'user-end-call',
    });
  };

  const handleAudio = ({isMuted}) => {
    vDispatch({type: isMuted ? 'mute' : 'unmute'});

    wsDispatch({
      type: 'send-audio-update',
      isMuted: isMuted,
    });
  };

  return (
    <ButtonContainer>
      {showUsers ? (
        <Button handleClick={handleUsers}><BackIcon /></Button>
      ) : (
        <>
          {isHost && !inCall && (
            <Button color="green" handleClick={handleStartCall}><CallIcon /></Button>
          )}
          {inCall && (
            <>
              {isMuted ? (
                <Button handleClick={() => handleAudio({isMuted: false})}><MutedIcon /></Button>
              ): (
                <Button handleClick={() => handleAudio({isMuted: true})}><UnmutedIcon /></Button>
              )}

              <Button color="red" handleClick={handleStopCall}><HangUpIcon /></Button>
            </>
          )}
          <Button handleClick={handleUsers}><UsersIcon /></Button>
          <Button color="red" handleClick={inCall ? handleWarning : handleExit}><DisconnectIcon /></Button>
        </>
      )}
    </ButtonContainer>
  );
};

ChatUIControlsCmp.propTypes = {
  isHost: PropTypes.bool,
  showUsers: PropTypes.bool,
  handleUsers: PropTypes.func,
  handleExit: PropTypes.func,
  handleWarning: PropTypes.func,
};

ChatUIControlsCmp.defaultProps = {
  isHost: false,
  showUsers: false,
};

export default ChatUIControlsCmp;
